import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";
import {NotificationModel} from "../../models/components/notification.model";

@Injectable({
    providedIn: "root"
})
export class NotificationService {
    private visibleNotification = new Subject<NotificationModel>();
    private hiddenNotification = new Subject<NotificationModel>();

    public get showNotificationObservable(): Observable<NotificationModel> {
        return this.visibleNotification.pipe();
    }

    public get hideNotificationObservable(): Observable<NotificationModel> {
        return this.hiddenNotification.pipe();
    }

    public showSuccess(title: string, text: string): void {
        this.showNotification("success", title, text);
    }

    public showWarning(title: string, text: string): void {
        this.showNotification("warning", title, text);
    }

    public showError(title: string, text: string): void {
        this.showNotification("error", title, text);
    }

    private showNotification(type: "success" | "warning" | "error", title: string, text: string): void {
        this.visibleNotification.next(new NotificationModel(type, title, text));
    }

    public hideNotification(notification: NotificationModel): void {
        this.hiddenNotification.next( notification);
    }
}
